import { createI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'
import { getStartingLocale } from '@/helpers/i18n'

export async function setupI18n() {
  const deepMerge = (target: any, source: any): any => {
    const result = { ...target }
    for (const key of Object.keys(source)) {
      if (
        result[key] &&
        typeof result[key] === 'object' &&
        !Array.isArray(result[key]) &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key])
      ) {
        result[key] = deepMerge(result[key], source[key])
      } else {
        result[key] = source[key]
      }
    }
    return result
  }

  const setNestedValue = (obj: any, path: string, value: any): any => {
    const keys = path.split('.')
    if (keys.length === 1) {
      return deepMerge(obj, { [path]: value })
    }
    const [first, ...rest] = keys
    return deepMerge(obj, { [first]: setNestedValue(obj[first] || {}, rest.join('.'), value) })
  }

  const getMessages = (lang: string) => {
    return Object.entries(messages as any).reduce((accum: any, current) => {
      const [key, value] = current
      const regex = new RegExp(`.${lang}`, 'g')
      if (key.match(regex)) {
        const newKey = key.replace(`.${lang}`, '')
        return setNestedValue(accum, newKey, value)
      }
      return accum
    }, {})
  }

  const loadLocaleMessages = () => {
    const locales = import.meta.env.VITE_I18N_SUPPORTED_LOCALES || ['en', 'de']
    const supportedLocales = locales.toString().split(',')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let localeMessages: any = {}

    if (supportedLocales.length > 1) {
      supportedLocales.forEach((lang: string) => {
        const translation = { [lang]: getMessages(lang) }
        localeMessages = { ...localeMessages, ...translation }
      })
    } else {
      const lang = import.meta.env.VITE_I18N_LOCALE || 'de'
      const translation = { [lang]: getMessages(lang) }
      localeMessages = { ...localeMessages, ...translation }
    }

    return localeMessages
  }

  // set the initial language to browser language if its supported,
  const locale = getStartingLocale()

  return createI18n({
    legacy: false,
    globalInjection: true,
    locale,
    fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'de',
    availableLocales: import.meta.env.VITE_I18N_SUPPORTED_LOCALES || ['en', 'de', 'fr', 'it'],
    messages: loadLocaleMessages(),
    missingWarn: false,
    fallbackWarn: false,
  })
}

const i18n = await setupI18n()
export default i18n
